export default {
  showToast: function (title, duration = 2000) {
    const toastDiv = document.querySelector('#my-toast-box');
    const toastTitleDiv = document.querySelector('#my-toast-title');
    toastTitleDiv.innerHTML = title;
    toastDiv.style = 'display: block;';
    setTimeout(() => {
      toastTitleDiv.innerHTML = '';
      toastDiv.style = 'display: none;';
    }, duration);
  },
  hideToast: function () {
    const toastDiv = document.querySelector('#my-toast-box');
    const toastTitleDiv = document.querySelector('#my-toast-title');
    toastTitleDiv.innerHTML = '';
    toastDiv.style = 'display: none;';
  },
};
